import React , {useState, useEffect, useCallback} from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Popup from '../../components/popup/ProductPopup'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'

const SolarCell = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;      
  const [open, setOpen] = useState(false);
  const [enquiry, setEnquiry] = useState('');

  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [product2, setProduct2] = useState(null);
  const apiUrl = apiBaseUrl+`productpage`;

  const callEnquiry = (txt) =>{
    setEnquiry(txt);
    setOpen(true);
  }

  const fetchInfo = useCallback(() => {
    return axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setProduct2(res.data.product2)
    });
  },[]);


  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, [fetchInfo]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  return (
    <>
    <Header/>
    { loading && (<Loader /> )}	

	<div className="container" id="solar-cell"><hr/></div>

    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro">
                        <p className="blue">{product2?.name}</p>
                        <h2 className="heading">{product2?.heading}</h2>
                        <p>{product2?.description}</p>
                        <button 
                            className="btn btn-button margin-top-60" 
                            onClick={() => callEnquiry('Solar Cell')}>Enquire now
                        </button>                        
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 Products text-right">
                    <img src={`${siteUrl}${product2?.image}`} alt={product2?.name}/>               
                </div>
            </div>
        </div> 
    </section>
    
    {open ? <Popup prm={enquiry} closePopup={() => setOpen(false)} /> : null}    
    <Footer/>
    </>
  )
}

export default SolarCell